import { getValue } from '@mui/system'
import { useEffect, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { ConnectionsSwitchFields } from '../connections_switch_fields'
import { ConnectionFieldName } from './connection_field_name'
import { storage } from '@yuno/dashboard-container-mfe'
import { ConstantText } from '../../utils/constants'
import { useTranslation } from 'react-i18next'

export const ConnectionFormV2 = ({
  connectionName,
  connectionResponse,
  onSubmit,
  setFormValid,
  testKeyValues,
  currentMode,
  paramsCatalog,
  providerId,
  isAsync,
  status,
  error,
  handleHasChange,
}) => {
  const { t } = useTranslation()
  const { handleSubmit } = useForm()
  const [toggleState, setToggleState] = useState(false)
  const [isAvailableTest, setIsAvailableTest] = useState(false)
  const [params, setParams] = useState([])

  const methods = useForm({
    mode: 'onChange',
  })

  const {
    getValues,
    setValue,
    setError,
    reset,
    formState: { errors, isValid, isDirty },
  } = methods

  const returnPaymentMethods = (element) => {
    if (element) {
      let stringReturn = ''
      Object.entries(element).map((el) => {
        if (el[1]) {
          stringReturn += `${el[0]},`
        }
      })
      return stringReturn
    }
  }

  const handleSubmitForm = () => {
    const values = getValues()
    storage.setItem('tempValuesForm', values)
    if (values.COUNTRY === '' || !values.COUNTRY) {
      values.COUNTRY = 'GLOBAL'
    }

    const getParams = () => {
      const paramsReturn = []
      Object.entries(values).forEach((el) => {
        const value = el[1]
        if (value !== null && value !== undefined) {
          paramsReturn.push({
            param_id: el[0],
            value: value,
          })
        }
        if ((value === undefined || value === null) && connectionResponse) {
          const valueDefault = connectionResponse.params.find(
            (param) => param.param_id === el[0],
          )
          paramsReturn.push({
            param_id: el[0],
            value: valueDefault ? valueDefault.value === 'true' : false,
          })
        }
      })

      return paramsReturn
    }

    const paramsCreate = {
      provider_id: providerId,
      name: values.name?.trim(),
      payment_method_type: values.PAYMENT_METHOD,
      payment_methods: values.PAYMENT_METHODS,
      integration_type: values.INTEGRATION_TYPE,
      country: values.COUNTRY,
      params: getParams(),
      params_with_test_values: values.params_with_test_values,
    }
    onSubmit(paramsCreate)
  }

  useEffect(() => {
    if (status === 'idle') {
      reset()
    }
    if (status == 'error' && error == ConstantText.ERROR_MESSAGE_NAME) {
      setError(
        'name',
        { message: t('nameAlreadyExist') },
        { shouldFocus: true },
      )
    }
  }, [status, error])

  useEffect(() => {
    setFormValid(isDirty && isValid)

    if (currentMode === 'create') {
      handleHasChange(isValid)
    } else {
      handleHasChange(isValid && isDirty)
    }
  }, [isDirty, isValid])

  return (
    <FormProvider {...methods}>
      <form id="connection-form" onSubmit={handleSubmit(handleSubmitForm)}>
        <ConnectionFieldName />
        {paramsCatalog.map((field, index) => (
          <ConnectionsSwitchFields
            key={`key-connections-${index}`}
            item={field}
            options={field.options}
            index={index}
            connectionResponse={connectionResponse}
            isAsync={isAsync}
            testKeyValues={testKeyValues}
            currentMode={currentMode}
            toggleState={toggleState}
            setToggleState={setToggleState}
            isAvailableTest={isAvailableTest}
            setIsAvailableTest={setIsAvailableTest}
            params={params}
            setParams={setParams}
          />
        ))}
      </form>
    </FormProvider>
  )
}
